import { FormControl, Typography, Box, Table, TableBody, TableRow, TableCell } from "@mui/material"
import { FormDataConsumer, Labeled, NumberField, useTranslate } from 'react-admin'
import { InvoiceItem } from "../../GeneratedClients/FreeBillApi"
import Invoice from "../../domain/invoice/Invoice"

const TotalAmount = () => {

  const translate = useTranslate()

  const calculateGrossAmount = (items: InvoiceItem[]) => {
    const invoice = new Invoice(items)
    return invoice.getGrossAmount()
  }

  const calculateNetAmount = (items: InvoiceItem[]) => {
    const invoice = new Invoice(items)
    return invoice.getNetAmount()
  }

  const calculateTaxAmounts = (items: InvoiceItem[]) => {
    const invoice = new Invoice(items)
    return invoice.getTaxAmounts()
  }

  return (
    <FormDataConsumer>
      {({
        formData
      }) => {
        return (
          <Labeled width={"100%"}>
            <Box display={'flex'} justifyContent={'flex-end'} width={"100%"}>
              <Table size="small" sx={{width: '30%'}}>
                <TableBody>
                  <TableRow>
                    <TableCell><Typography variant="body2">{translate("resources.invoices.netAmount")}</Typography></TableCell>
                    <TableCell align="right">
                      <FormControl>
                        <NumberField 
                          record={{value: calculateNetAmount(formData.invoiceItems)}} 
                          source="value"
                          options={{ style: 'currency', currency: 'EUR' }}
                        />
                      </FormControl>
                    </TableCell>
                  </TableRow>
                  {
                    calculateTaxAmounts(formData.invoiceItems).map((taxAmount, index) => {
                      if (taxAmount.isDisplayed) return (
                        <TableRow key={index + 1}>
                          <TableCell><Typography variant="body2">{translate("resources.invoices.taxAmount")} {taxAmount.name}</Typography></TableCell>
                          <TableCell align="right">
                            <FormControl>
                              <NumberField 
                                record={{value: taxAmount.amount}} 
                                source="value"
                                options={{ style: 'currency', currency: 'EUR' }}
                              />
                            </FormControl>
                          </TableCell>
                        </TableRow>  
                      )
                    })
                  }
                  <TableRow>
                    <TableCell><Typography variant="body2">{translate("resources.invoices.grossAmount")}</Typography></TableCell>
                    <TableCell align="right">
                      <FormControl>
                        <NumberField 
                          record={{value: calculateGrossAmount(formData.invoiceItems)}} 
                          source="value"
                          options={{ style: 'currency', currency: 'EUR' }}
                        />
                      </FormControl>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Labeled>
        )
      }}
    </FormDataConsumer>
  )
}

export default TotalAmount